import {
	LOGIN_ROUTE_ID,
} from 'root/src/shared/descriptions/routes/routeIds'
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'
import { authApi } from 'root/src/shared/util/authApi'

export default ({ password }) => async () => {
	const params = new URLSearchParams(window.location.search)
	const code = params.get('code')

	if (!code) {
		throw 'Code does not exist'
	}

	await authApi.resetPassword({
		password,
		code,
	})

	return pushRouteClient({ routeId: LOGIN_ROUTE_ID })
}
